module.exports = {
    aviogo: {
        theme: require('./aviogo').theme,
        title: require('./aviogo').title,
    },
    'den-haag': {
        theme: require('./den-haag').theme,
        title: require('./den-haag').title,
    },
    dominos: {
        theme: require('./dominos').theme,
        title: require('./dominos').title,
    },
    glimble: {
        theme: require('./glimble').theme,
        title: require('./glimble').title,
    },
    klushub: {
        theme: require('./klushub').theme,
        title: require('./klushub').title,
    },
    mobian: {
        theme: require('./mobian').theme,
        title: require('./mobian').title,
    },
};


// WEBPACK FOOTER //
// ./src/tenants/index.js